import { render } from "./DateBox.vue?vue&type=template&id=5f17951b&scoped=true"
import script from "./DateBox.vue?vue&type=script&lang=js"
export * from "./DateBox.vue?vue&type=script&lang=js"

import "./DateBox.vue?vue&type=style&index=0&id=5f17951b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f17951b"]])

export default __exports__